module.exports = "/* these are already supplied ...\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 projectionMatrix;\nuniform mat4 viewMatrix;\nuniform mat3 normalMatrix;\nuniform vec3 cameraPosition;\t\nattribute vec3 position;\nattribute vec3 normal;\nattribute vec2 uv;\nattribute vec2 uv2;\n*/\n\nvarying vec2 _position;\n\nvoid main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n\n\t_position = uv;\n\n}"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/components/MetaBalls/shaders/plane.vert
// module id = 237
// module chunks = 0